import { MantineSize, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const useSmallerView = (size: MantineSize = 'xs') => {
  const theme = useMantineTheme();
  return useMediaQuery(`(max-width: ${theme.breakpoints[size]})`)!;
};
